module.exports = __webpack_public_path__ + "img/humidity.a3a62101.svg";